export default __webpack_public_path__ + "static/media/hr_rag.5a955014.PNG";